document.addEventListener('submit', function (event) {
  const form = event.target.closest('[data-back-in-stock-form]');

  if (!form) return;

  event.preventDefault();

  const emailInput = form.querySelector('input[type="email"]');
  const submitButton = form.querySelector('[data-back-in-stock-submit]');
  const buttonText = form.querySelector('.back-in-stock-button-text');
  const successMessage = form.querySelector('[data-back-in-stock-success]');
  const errorMessage = form.querySelector('[data-back-in-stock-error]');

  if (!emailInput.checkValidity()) {
    emailInput.reportValidity();
    return;
  }

  successMessage.hidden = true;
  errorMessage.hidden = true;

  submitButton.disabled = true;

  const originalText = buttonText.textContent;

  buttonText.textContent = 'Sending...';

  const formData = new FormData(form);

  fetch('/contact', {
    method: 'POST',
    body: formData,
    redirect: 'manual'
  })
    .then(function (response) {

      /*
       * Shopify successfully processes the contact form
       * and redirects to:
       *
       * /contact?contact_posted=true
       *
       * A redirect response is therefore SUCCESS, not an error.
       */

      if (
        response.type === 'opaqueredirect' ||
        response.status === 301 ||
        response.status === 302 ||
        response.status === 303
      ) {
        return true;
      }

      if (response.ok) {
        return true;
      }

      throw new Error('Contact form submission failed');
    })
    .then(function () {

      successMessage.hidden = false;

      emailInput.value = '';

      buttonText.textContent = 'Email submitted';

      submitButton.disabled = true;

    })
    .catch(function (error) {

      console.error('Back in stock form error:', error);

      errorMessage.hidden = false;

      buttonText.textContent = originalText;

      submitButton.disabled = false;
    });
});